<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/rounded-corner.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <div>Rounded</div>
  </app-access-item-header>

  <app-access-item-cta>
    <app-switch [smallish]="true">
      <input
        type="checkbox"
        id="theme-rounded-corners"
        [ngModel]="theme().section.rounded_corners"
        (ngModelChange)="updateRoundedCorners($event)"
      />
      <label for="theme-rounded-corners" data-test-id="theme-rounded-corners"></label>
    </app-switch>
  </app-access-item-cta>
</app-access-item>
